import ReactGA from "react-ga4"

export const pubnubPublishKey = process.env.REACT_APP_PUBNUB_PUBLISH_KEY;
export const pubnubSubscribeKey = process.env.REACT_APP_PUBNUB_SUBSCRIBE_KEY;

export const googleAPiKey = process.env.REACT_APP_GOOGLE_API_KEY;

export const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

export const rideStatus = {
  1: "Created",
  2: "Waiting For Driver Assign",
  3: "Waiting for Approval",
  4: "Accepted By Driver",
  5: "On route", //# STARTED — driver assigned & en route, in progress
  6: "Arrived",
  7: "On route", //  # On route (In Progress)
  8: "Completed",
  9: "Cancelled By Driver",
  10: "Cancelled By Client",
  11: "Expired",
  12: "Cancelled Before Driver Assign"
}

// Format backend status strings like "DRIVER_ACCEPTED" → "Driver Accepted"
export const formatRideGroupStatus = (status) => {
  if (!status) return ""
  return status
    .toLowerCase()
    .split("_")
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ")
}

export const gaActions = {
  client: {
    category: "CLIENT",
    action: {
      add: "ADD",
      delete: "DELETE",
      hold: "HOLD",
      release: "RELEASE",
      view: "VIEW",
      approve: "Approve"
    }
  }
}

export const GoogleAnalyticsData = (category, action) => {
  ReactGA.event({
    category: category,
    action: action
  })
}

export const INSPECTION_TYPE = [
  {
    id:1,
    name:"PRE"
  },
  {
    id:2,
    name:"POST"
  },
]

export const INSPECTION_CATEGORY = [
  {
    id:1,
    name:"Front of Vehicle"
  },
  {
    id:2,
    name:"Engine Compartment"
  },
  {
    id:3,
    name:"Tire"
  },
  {
    id:4,
    name:"Exterior Lights"
  },
  {
    id:5,
    name:"Driver Fuel Area"
  },
  {
    id:6,
    name:"Rear of Vehicle"
  },
  {
    id:7,
    name:"In Cab"
  },
  {
    id:8,
    name:"Emergency Equipment"
  },
  {
    id:9,
    name:"Others"
  },
]

export const STOPS_CALL_INTERVAL = 1000 * 30;

export const STOP_STATUS = {
  1: "PENDING",
  2: "STARTED",
  3: "ARRIVED",
  4: "COMPLETED",
  5: "NO SHOW",
  6: "CANCELLED"
}

export const STOP_TYPE = {
  1: "PICKUP",
  2: "DROP OFF",
  3: "A/M PICKUP",
  4: "A/M DROP OFF"
}